var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.496,
    height: 22.484,
    viewBox: "0 0 22.496 22.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(-2.25 -2.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(2.25 2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M22.624,15.823a4,4,0,0,1-4.428,0,2.247,2.247,0,0,0-2.5,0,3.951,3.951,0,0,1-4.416,0,2.247,2.247,0,0,0-2.5,0,3.951,3.951,0,0,1-4.416,0l-1.51-1h-.6v1.361c0,.127.012.242.023.369h.842a.828.828,0,0,1,.484.15l1.73,1.153a2.247,2.247,0,0,0,2.5,0,3.951,3.951,0,0,1,4.416,0,2.247,2.247,0,0,0,2.5,0,3.951,3.951,0,0,1,4.416,0,2.247,2.247,0,0,0,2.5,0L23.4,16.7a.889.889,0,0,1,.484-.15h.842c0-.127.023-.242.023-.369V14.82h-.6l-1.51,1Z",
    transform: "translate(-2.25 -0.326)",
    fill: "#2772af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M22.624,12.753a4,4,0,0,1-4.428,0,2.247,2.247,0,0,0-2.5,0,3.951,3.951,0,0,1-4.416,0,2.247,2.247,0,0,0-2.5,0,3.951,3.951,0,0,1-4.416,0l-1.51-1h-.6v1.81h.865a.828.828,0,0,1,.484.15l1.73,1.153a2.247,2.247,0,0,0,2.5,0,3.951,3.951,0,0,1,4.416,0,2.247,2.247,0,0,0,2.5,0,3.951,3.951,0,0,1,4.416,0,2.247,2.247,0,0,0,2.5,0L23.4,13.71a.889.889,0,0,1,.484-.15h.865V11.75h-.6l-1.51,1Z",
    transform: "translate(-2.25 -0.796)",
    fill: "#2772af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M18.1,2.25H8.88A6.638,6.638,0,0,0,2.25,8.88v2.594h.865a.828.828,0,0,1,.484.15l1.73,1.153a2.247,2.247,0,0,0,2.5,0,3.951,3.951,0,0,1,4.416,0,2.247,2.247,0,0,0,2.5,0,3.951,3.951,0,0,1,4.416,0,2.247,2.247,0,0,0,2.5,0l1.73-1.153a.889.889,0,0,1,.484-.15h.865V8.88a6.638,6.638,0,0,0-6.63-6.63Zm-1.695,5.8a.863.863,0,0,1-1.222,0l-.83-.83V9.745a.865.865,0,0,1-1.73,0V7.22l-.83.83a.864.864,0,1,1-1.222-1.222l2.306-2.306a.87.87,0,0,1,1.222,0l2.306,2.306a.87.87,0,0,1,0,1.222Z",
    transform: "translate(-2.25 -2.25)",
    fill: "#2772af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M22.578,18.823a4,4,0,0,1-4.428,0,2.247,2.247,0,0,0-2.5,0,3.951,3.951,0,0,1-4.416,0,2.247,2.247,0,0,0-2.5,0,3.951,3.951,0,0,1-4.416,0l-1.51-1H2.55a6.638,6.638,0,0,0,6.284,4.531h9.224a6.638,6.638,0,0,0,6.284-4.531h-.254l-1.51,1Z",
    transform: "translate(-2.204 0.133)",
    fill: "#2772af"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.490a72ec1ebffacf7bacfa1af00eae42.svg";
export { ForwardRef as ReactComponent };